import React from 'react'
import { Grid, Row, Col} from 'react-bootstrap'
import {Gmaps, Marker, InfoWindow, Circle} from 'react-gmaps';

const coords = {
  lat: 10.3414597,
  lng: 76.2785342
};



const internals = {};

internals.styles = {
  map: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '100px'
  },
  content: {
    maxWidth: '50vw'
  },
  scroll: {
    position: 'relative',
    top: '15vh'
  }
};

const API_KEY = 'AIzaSyBCPuCiuwMJ6MeIgxHZnUkkDSn8xKrskd8'

const params = {v: '3.exp', key: API_KEY };

class Location extends React.Component{

    onMapCreated(map) {
      map.setOptions({
        disableDefaultUI: false
      });
    }

    onDragEnd(e) {
      console.log('onDragEnd', e);
    }

    onCloseClick() {
      console.log('onCloseClick');
    }

    onClick(e) {
      console.log('onClick', e);
    }

    render() {
      return (
        <div id='location'>
          <h1>Location</h1>
          <div style = {internals.styles.map}>
        <Gmaps
          width={'80%'}
          height={'80%'}
          lat={coords.lat}
          lng={coords.lng}
          zoom={14}
          params={params}
          onMapCreated={this.onMapCreated}>
          <Marker
            lat={coords.lat}
            lng={coords.lng}
            draggable={true}
            onDragEnd={this.onDragEnd} />
          <InfoWindow
            lat={coords.lat}
            lng={coords.lng}
            content={'Kakkara Dental Clinic'}
            onCloseClick={this.onCloseClick} />
          <Circle
            lat={coords.lat}
            lng={coords.lng}
            radius={500}
            onClick={this.onClick} />
        </Gmaps>
        </div>
        </div>
      );
    }

  };

  export default Location;



// WEBPACK FOOTER //
// ./src/Location/Location.jsx